import { render, staticRenderFns } from "./SmsTemplate.vue?vue&type=template&id=59b7639f&scoped=true"
import script from "./SmsTemplate.vue?vue&type=script&lang=js"
export * from "./SmsTemplate.vue?vue&type=script&lang=js"
import style0 from "./SmsTemplate.vue?vue&type=style&index=0&id=59b7639f&prod&scoped=true&lang=css"
import style1 from "./SmsTemplate.vue?vue&type=style&index=1&id=59b7639f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b7639f",
  null
  
)

export default component.exports